import { createContext } from 'react'

interface ModalControlType {
  handleModalOpen: () => void
  handleModalClose: () => void
}

const initialModalControlContext: ModalControlType = {
  handleModalOpen: () => {},
  handleModalClose: () => {},
}

export const ModalControlContext = createContext<ModalControlType>(
  initialModalControlContext
)
